module.exports = __webpack_public_path__ + "assets/group-a0d0cf.svg";